// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._6d6147{position:relative;margin-left:var(--left-offset)}@media screen and (min-width: 62em){._6d6147{padding-top:var(--top-bar-height)}}main{padding:var(--medium-spacer) var(--xlarge-spacer)}.bleed{padding:0;margin:calc(-1*var(--medium-spacer)) calc(-1*var(--xlarge-spacer))}.bleed.has-padding{padding:var(--medium-spacer)}@media print{.a39637 main{display:none}}.eebd18{margin-left:auto;margin-right:auto}._4c4d9a{max-width:120em}._5dc4c1{max-width:60em}._8af920{max-width:50em}.b834c8{max-width:40em}._908488{max-width:32em}.e5be6c{position:absolute;width:1rem;height:1rem}@media print{.e5be6c{display:none}}._37bb0b{position:fixed;top:auto;right:0;bottom:0;left:var(--left-offset);height:.5rem;background:var(--sidebar-color-highlight);z-index:50}._37bb0b .e5be6c{top:auto;right:auto;bottom:100%;left:0;fill:var(--sidebar-color-highlight);transform:rotate(-90deg)}.bdcb7c{position:fixed;top:var(--top-bar-height);right:0;bottom:.5rem;left:auto;width:.5rem;background:var(--sidebar-color-highlight);z-index:50}.bdcb7c ._769b94{top:0;right:100%;bottom:auto;left:auto;fill:var(--sidebar-color-highlight);transform:rotate(90deg)}.bdcb7c .ab3de8{top:auto;right:100%;bottom:0;left:auto;fill:var(--sidebar-color-highlight);transform:rotate(180deg)}._5b4aa4{padding:var(--spacer) var(--medium-spacer)}._5b4aa4.ab3396{visibility:hidden}", ""]);
// Exports
exports.locals = {
	"layout": "_6d6147",
	"print-sidebar": "a39637",
	"printSidebar": "a39637",
	"container": "eebd18",
	"large-container": "_4c4d9a eebd18",
	"largeContainer": "_4c4d9a eebd18",
	"default-container": "_5dc4c1 eebd18",
	"defaultContainer": "_5dc4c1 eebd18",
	"medium-container": "_8af920 eebd18",
	"mediumContainer": "_8af920 eebd18",
	"small-container": "b834c8 eebd18",
	"smallContainer": "b834c8 eebd18",
	"tiny-container": "_908488 eebd18",
	"tinyContainer": "_908488 eebd18",
	"corner": "e5be6c",
	"bottom-border": "_37bb0b",
	"bottomBorder": "_37bb0b",
	"right-border": "bdcb7c",
	"rightBorder": "bdcb7c",
	"top-corner": "_769b94",
	"topCorner": "_769b94",
	"bottom-corner": "ab3de8",
	"bottomCorner": "ab3de8",
	"footer": "_5b4aa4",
	"placeholder": "ab3396"
};
module.exports = exports;
